<template>
  <div id="jumbotron">
    <div class="overlay"></div> <!-- Blue blur overlay -->
    <div class="container content">
      <p class="title">About Us</p>
    </div>
  </div>

  <div class="container mt-5">

    <h1>About Us: A Commitment to Educational Excellence</h1>

    <p>
      At English Matters, we specialize in teaching English and other key languages to students aged 5 to young adults. Our programs focus on building fluency, academic success, and essential communication skills that will benefit students for life.
    </p>
    
    <p>
      As part of Edu Circle Group, we are backed by a team of education professionals with years of experience in international student placement, academic counseling, and language instruction. This allows us to ensure that our courses are highly effective, engaging, and aligned with global education standards.
    </p>
    
    <div class="container py-5">
      <h2 class="text-center mb-4">Meet Our Leadership – Experts Who Care</h2>
      <p>
        Our leadership team is committed to academic quality, student engagement, and preparing learners for success in an increasingly globalized world.
      </p>
      <div class="row justify-content-center mt-5">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/Nas.webp" class="card-img-top" alt="Pricipal, Nasiha Nas">
            <div class="card-body text-center">
              <h5 class="card-title">Nasiha Nas</h5>
              <p class="card-subtitle">Principal</p>
              <p class="card-text">
                A dedicated and experienced educator, specializing in English language instruction and academic excellence, ensuring high-quality learning outcomes for students.
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/matthew.jpg" class="card-img-top" alt="Group CEO, Matthew Gan">
            <div class="card-body text-center">
              <h5 class="card-title">Matthew Gan</h5>
              <p class="card-subtitle">Group CEO</p>
              <p class="card-text">
                A respected education specialist with 20+ years of experience in student guidance, assessments, and academic excellence.
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/nicholas.jpg" class="card-img-top" alt="Centre Director, Nicolas Chan">
            <div class="card-body text-center">
              <h5 class="card-title">Nicolas Chan</h5>
              <p class="card-subtitle">Centre Director</p>
              <p class="card-text">
                An experienced educator and administrator with a strong background in student engagement and academic management, ensuring a high-quality learning environment for all students.
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/olivier.webp" class="card-img-top" alt="Professor Dr. Olivier Cane (Academic Advisor and French Principal)">
            <div class="card-body text-center">
              <h5 class="card-title">Professor Dr. Olivier Cane</h5>
              <p class="card-subtitle">Academic Advisor and French Principal</p>
              <p class="card-text">
                Founder of The French Academy, President of Riviera University, and Dean at Genovasi University. An expert in language education and curriculum design.
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
          <div class="card">
            <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/profiles/leon.enc" class="card-img-top" alt="Chief Technology Officer, Leon Lim">
            <div class="card-body text-center">
              <h5 class="card-title">Leon Lim</h5>
              <p class="card-subtitle">Chief Technology Officer</p>
              <p class="card-text">
                Innovator in education technology, ensuring our digital learning tools are cutting-edge and effective.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  #jumbotron {
    position: relative;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/banner-buiding.webp");
    background-size: cover;
    background-position: center;
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Blue blurry overlay */
  #jumbotron .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(19, 5, 115, 0.75); /* Blue tint */
  }

  #jumbotron .content {
    position: relative;
    z-index: 2;
  }

  #jumbotron .title {
    color: white;
    font-size: 5em;
    font-weight: bold;
  }

 .card {
    border: none;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out;
    margin-bottom: 2em;
  }
  .card:hover {
    transform: translateY(-5px);
  }
  .card img {
    width: 70%;
    height: auto;
    object-fit: cover;
    border-radius: 50%;
    margin: auto;
    margin-top: 1em;
    border: 4px solid white;
    display: block;
  }
  .card-title {
    font-size: 1.25rem;
    font-weight: bold;
  }
  .card-subtitle {
    font-size: 1rem;
    font-weight: bold;
    color: #FF4d37;
  }
  .card-text {
    color: #555;
  }
</style>